import {
  SIDE_NAV_LIGHT,
  NAV_TYPE_SIDE,
  DIR_LTR, BODY_BACKGROUND
} from "constants/ThemeConstant";


export var SERVER_TYPE = "Production";
//SERVER_TYPE = "Development";
export const APP_NAME = SERVER_TYPE === "Development"
  ? "Task Source" : "PCTUDE HRMS";
export const APP_URL =
  SERVER_TYPE === "Development"
    ? "http://localhost:3000/"
    : "https://pctude.com/";

export const APP_EMAIL = "";
export const LOGIN_BG_IMAGE = `${APP_URL}img/login-bg.jpg`;
export const LOGIN_BANNER_IMAGE = `${APP_URL}img/login-banner.png`; // Office workers with time clock banner
export const BANNER_LOGO_LG = `${APP_URL}img/logo-lg-resized.png`;
export const PLACEHOLDER_BASE_URL_DEFAULT = `${APP_URL}img/`;
export const PLACEHOLDER_BASE_URL_FILE = `${APP_URL}img/icons8-document-512.png`;
export const PLACEHOLDER_BASE_URL = `${APP_URL}img/userPlaceHolder.png`;
export const ONERROR_BASE_URL = `${APP_URL}img/userPlaceHolder.png`;
export const ONERROR_BASE_URL_HOLIDAY = `${APP_URL}img/login-bg.jpg`;
export const PAGE_NOT_FOUN_IMAGE_URL = `${APP_URL}img/404.webp`;
export const APP_LOGO = SERVER_TYPE === "Development" ? `${APP_URL}img/logo-lg-resized.png` : `${APP_URL}img/logo-lg.png`;
export const APP_LOGO_SMALL = SERVER_TYPE === "Development" ? `${APP_URL}img/logo-sm-white.png` : `${APP_URL}img/logo-sm.png`;
export const HEADER_APP_LOGO = SERVER_TYPE === "Development" ? `${APP_URL}img/logo-sm-white.png` : `${APP_URL}img/logo-lg-white.png`;
export const HEADER_APP_LOGO_SMALL = SERVER_TYPE === "Development" ? `${APP_URL}img/logo-sm-white.png` : `${APP_URL}img/logo-white.png`;
export const APP_PREFIX_PATH = "app";
export const AUTH_PREFIX_PATH = "app";
export const REDIRECT_URL_KEY = "id";
export const AUTHENTICATED_ENTRY = `${APP_PREFIX_PATH}/dashboard`;
export const UNAUTHENTICATED_ENTRY = ``;
export const REDIRECT = `/${APP_PREFIX_PATH}`;
export const AUTH_TOKEN = "auth_token";
export const NOTIAPPID = "82cb04e5-43cf-4429-ae2f-abd9d75fac80";
export const BUFFERID = "82cb04e5-43cf-4429-ae2f-abd9d75fac80";
export const MainThemeBackgroundColor = "linear-gradient(to bottom, #0a2a7a, #0d47a1)";

export const THEME_CONFIG = {
  navCollapsed: false,
  sideNavTheme: "#377DFF",
  sideNavTheme2: SIDE_NAV_LIGHT, //testing
  locale: "en",
  navType: NAV_TYPE_SIDE,
  topNavColor: "#377DFF",
  headerNavColor: "#fff",
  mobileNav: false,
  currentTheme: "light",
  direction: DIR_LTR,
  blankLayout: false,
  DivFormBackground: "#377DFF",
  ButtonBackground: "#377DFF",
  ButtonCancelBackground: "#ff6b72",
  ThemeMainColor: "#377DFF",
  BODY_BG_COLOR: BODY_BACKGROUND, // Body background color - same as dashboard
  LOGO_HEIGHT: "150px", // Logo height for login/forgot/reset pages and sidebar
  HEADER_APP_LOGO_HEIGHT: "auto"
};

//==================== api call url =================
export const API_ENDPOINT_URL =
  SERVER_TYPE === "Development"
    ? "http://localhost:4000/api/"
    : "https://billerway.com/pctude-api/";
export const API_BASE_URL = `${API_ENDPOINT_URL}server`;
export const SERVER_LOGO_LG = `${API_BASE_URL}/logos/logo.png`;
export const API_BASE_URL_FILE = `${API_ENDPOINT_URL}server/commen/upload`;
export const IMAGE_BASE_URL = `${API_ENDPOINT_URL}server/`;
export const PDF_BASE_URL = `${API_ENDPOINT_URL}server/`;
export const VIDEO_BASE_URL = `${API_ENDPOINT_URL}server/`;
export const CSV_BASE_URL = `${API_ENDPOINT_URL}server/`;
export const FILE_BASE_URL = `${API_ENDPOINT_URL}server/`;
export const POLICY_TYPE = [
  {
    fulllable: "Project Go-Live Incentive",
    lable: "Project",
    levelName: "project",
    descriptions:
      "Earn ₹1,500 for projects going live on time: standard projects within 6 weeks, Shopify plug-in within 4 weeks, and custom projects before due date.",
    activeFlag: 1,
    deleteFlag: 0,
    incentive: [
      {
        name: "Standard Projects",
        condition: "Go-live within 6 weeks from official project kick-off",
        type: "Fixed",
        value: 1500,
        target: 1,
        subCondition: false,
        activeFlag: 1,
        select: true,
      },
      {
        name: "Shopify Plug-in Projects",
        condition: "Go-live within 4 weeks from official project kick-off",
        type: "Fixed",
        value: 1500,
        target: 1,
        subCondition: false,
        activeFlag: 1,
        select: false,
      },
      {
        name: "Custom Projects",
        condition: "Go-live before management-assigned due date",
        type: "Fixed",
        value: 1500,
        target: 1,
        subCondition: false,
        activeFlag: 1,
        select: false,
      },
    ],
  },
  {
    fulllable: "Employee Recognition/Appreciation Incentive",
    lable: "Appreciation",
    levelName: "appreciation",
    descriptions:
      "Earn ₹3,000 for formal appreciation from Builder.ai or Company Head. Applicable to full-time employees.",
    activeFlag: 1,
    deleteFlag: 0,
    incentive: [
      {
        name: "Appreciation Incentive",
        condition:
          "₹3,000 incentive for employees who demonstrate exceptional performance, commitment, or contribute significantly beyond expectations.",
        type: "Fixed",
        value: 3000,
        target: 1,
        subCondition: false,
        activeFlag: 1,
        select: true,
      },
    ],
  },
  {
    fulllable: "New Sale, Upselling And Plan Upgrade Incentive",
    lable: "Sales",
    levelName: "sales",
    description:
      "Earn ₹16,000 for new project sales, ₹12,000 for upselling, and ₹4,000 for plan upgrades by Project Management & Digital Marketing team members.",
    activeFlag: 1,
    deleteFlag: 0,
    incentive: [
      {
        name: "New Sale",
        condition: "Reward for bringing in a brand new project sale.",
        type: "Fixed",
        value: 16000,
        target: 1,
        subCondition: false,
        activeFlag: 1,
        select: true,
      },
      {
        name: "Upselling",
        condition:
          "Reward for successfully upselling additional services or features to existing clients.",
        type: "Fixed",
        value: 12000,
        target: 1,
        subCondition: false,
        activeFlag: 1,
        select: false,
      },
      {
        name: "Plan Upgrade",
        condition:
          "Reward for convincing a client to move to a higher-tier plan.",
        type: "Fixed",
        value: 4000,
        target: 1,
        subCondition: false,
        activeFlag: 1,
        select: false,
      },
    ],
  },
  {
    fulllable: "Client Google Review Incentive",
    lable: "Review",
    levelName: "review",
    description:
      "Earn ₹1,000 incentive for receiving a genuine, positive review from a verified client on the company’s official Google profile.",

    activeFlag: 1,
    deleteFlag: 0,
    incentive: [
      {
        name: "Google Review",
        condition:
          "₹1,000 incentive for receiving a positive Google review from a client.",
        type: "Fixed",
        value: 1000,
        target: 1,
        subCondition: false,
        activeFlag: 1,
        select: true,
      },
    ],
  },
  {
    fulllable: "Attendance Incentive",
    lable: "Attendance",
    levelName: "attendance",
    description:
      "Earn 5% of gross salary as incentive for full attendance in a month without  leaves, late comings, early leavings, or power outages. Employees are eligible for Incentive only after completion of 3 months from their joining date",
    activeFlag: 1,
    incentive: [
      {
        name: "Attendance Bones",
        condition:
          "5% of basic salary as incentive for full attendance without unapproved leaves in a month.",
        type: "Percentage",
        value: 5,
        target: 100,
        subCondition: false,
        activeFlag: 1,
        select: true,
      },
    ],
  },
  {
    fulllable: "Lab Grown Incentive",
    lable: "Lab Grown",
    levelName: "labgrown",
    description:
      "Earn ₹2,000 for every 5 lab-grown accounts handled. ₹200 for each additional lab-grown account beyond the initial 5 in the same month.",
    activeFlag: 1,
    deleteFlag: 0,
    incentive: [
      {
        name: "Every 5 Accounts",
        condition:
          "Earn ₹2,000 for every 5 lab-grown accounts handled. And earn ₹200 for each additional lab-grown account beyond the initial 5.",
        type: "Fixed",
        value: [2000, 200],
        target: [5, 1],
        subCondition: true,
        select: true,
        subConditions: [
          {
            target: 5,
            value: 2000,
          },
          {
            target: 1,
            value: 200,
          },
        ],
        activeFlag: 1,
      },
    ],
  },
  {
    fulllable: "PCTUDE Referral Incentive",
    lable: "PCTUDE Referral",
    levelName: "referral",
    description:
      "Earn ₹2,500 for each employee-referred lead that converts to a paid PCTUDE client.",
    activeFlag: 1,
    deleteFlag: 0,
    incentive: [
      {
        name: "Referral Bonus",
        condition:
          "₹2,500 incentive for referring a successful PCTUDE client.",
        type: "Fixed",
        value: 2500,
        target: 1,
        subCondition: false,
        select: true,
        activeFlag: 1,
      },
    ],
  },
];
export const ACCESS_PERMISSION_LEVEL = [
  {
    fulllable: "Handover",
    lable: "Handover",
    levelName: "handover",
    permissions: ["list", "view", "update", "create"],
    defaultPermissions: ["view"],
  },
  {
    fulllable: "My Handover",
    lable: "My HNDVR",
    levelName: "myhandover",
    permissions: ["list", "view", "update", "create"],
    defaultPermissions: ["view"],
  },
  {
    fulllable: "Attendance",
    lable: "Attnd",
    levelName: "attendance",
    permissions: ["list", "view", "update", "create"],
    defaultPermissions: ["view"],
  },
  {
    fulllable: "My Attendance",
    lable: "My Attnd",
    levelName: "myattendance",
    permissions: ["list", "view", "update", "create"],
    defaultPermissions: ["view"],
  },
  {
    fulllable: "Regularization-Request",
    lable: "Reg-Req",
    levelName: "reg-request",
    permissions: ["list", "view", "update", "create"],
    defaultPermissions: ["view", "update", "create"],
  },
  {
    fulllable: "My Regularization-Request",
    lable: "My Reg-Req",
    levelName: "myreg-request",
    permissions: ["list", "view", "update", "create"],
    defaultPermissions: ["view", "update", "create"],
  },
  {
    fulllable: "Leave",
    lable: "Leave",
    levelName: "leave",
    permissions: ["list", "view", "update", "create"],
    defaultPermissions: ["view", "update", "create"],
  },
  {
    fulllable: "My Leave",
    lable: "My Leave",
    levelName: "myleave",
    permissions: ["list", "view", "update", "create"],
    defaultPermissions: ["view", "update", "create"],
  },
  {
    fulllable: "Comp-off",
    lable: "Comp-off",
    levelName: "compoff",
    permissions: ["list", "view", "update", "create"],
    defaultPermissions: ["view", "update", "create"],
  },
  {
    fulllable: "My Comp-off",
    lable: "My Comp-off",
    levelName: "mycompoff",
    permissions: ["list", "view", "update", "create"],
    defaultPermissions: ["view", "update", "create"],
  },
  {
    fulllable: "Reimbursement",
    lable: "Reimb",
    levelName: "reimbursement",
    permissions: ["list", "view", "update", "create"],
    defaultPermissions: ["view", "update", "create"],
  },
  {
    fulllable: "Myt Reimbursement",
    lable: "My Reimb",
    levelName: "myreimbursement",
    permissions: ["list", "view", "update", "create"],
    defaultPermissions: ["view", "update", "create"],
  },

  {
    fulllable: "Incentive",
    lable: "Inctv",
    levelName: "incentive",
    permissions: ["list", "view", "update", "create"],
    defaultPermissions: ["view", "update", "create"],
  },
  {
    fulllable: "My Incentive",
    lable: "My Inctv",
    levelName: "myincentive",
    permissions: ["list", "view", "update", "create"],
    defaultPermissions: ["view", "update", "create"],
  },
  {
    fulllable: "Holiday",
    lable: "Holiday",
    levelName: "holiday",
    permissions: ["list", "view", "update", "create"],
    defaultPermissions: ["view", "update", "create"],
  },
  {
    fulllable: "My Holiday",
    lable: "My Holiday",
    levelName: "myholiday",
    permissions: ["list", "view", "update", "create"],
    defaultPermissions: ["view", "update", "create"],
  },
  {
    fulllable: "Incentive Policies",
    lable: "Inctv-Plcy",
    levelName: "incentivepolicy",
    permissions: ["list", "view", "update", "create"],
    defaultPermissions: ["view", "update", "create"],
  },

  {
    fulllable: "Department",
    lable: "Department",
    levelName: "department",
    permissions: ["list", "view", "update", "create"],
    defaultPermissions: ["view"],
  },
  {
    fulllable: "Announcement",
    lable: "Announcement",
    levelName: "announcement",
    permissions: ["list", "view", "update", "create"],
    defaultPermissions: ["view"],
  },
  {
    fulllable: "Team",
    lable: "Team",
    levelName: "team",
    permissions: ["list", "view", "update", "create"],
    defaultPermissions: ["view"],
  },
  {
    fulllable: "Admin",
    lable: "Admin",
    levelName: "admin",
    permissions: ["list", "view", "update", "create"],
    defaultPermissions: ["view"],
  },
  {
    fulllable: "Employee",
    lable: "Employee",
    levelName: "employee",
    permissions: ["list", "view", "update", "create"],
    defaultPermissions: ["view"],
  },
  {
    fulllable: "Onboarding",
    lable: "Onboarding",
    levelName: "registration",
    permissions: ["list", "view", "update", "create"],
    defaultPermissions: ["view"],
  },
  {
    fulllable: "Unit",
    lable: "Unit",
    levelName: "unit",
    permissions: ["list", "view", "update", "create"],
    defaultPermissions: ["view"],
  },
  {
    fulllable: "Shift",
    lable: "Shift",
    levelName: "shift",
    permissions: ["list", "view", "update", "create"],
    defaultPermissions: ["view"],
  },
  {
    fulllable: "Compensation",
    lable: "Compensation",
    levelName: "compensation",
    permissions: ["list", "view", "update", "create"],
    defaultPermissions: ["view"],
  },
  {
    fulllable: "Payroll",
    lable: "Payroll",
    levelName: "payroll",
    permissions: ["list", "view", "update", "create"],
    defaultPermissions: ["view"],
  },
  {
    fulllable: "My Salary Slip",
    lable: "My Salary Slip",
    levelName: "mysalaryslip",
    permissions: ["list", "view", "update", "create"],
    defaultPermissions: ["view"],
  },
  {
    fulllable: "Workflow",
    lable: "Workflow",
    levelName: "workflow",
    permissions: ["list", "view", "update", "create"],
    defaultPermissions: ["view"],
  },
  {
    fulllable: "Project",
    lable: "Project",
    levelName: "project",
    permissions: ["list", "view", "update", "create"],
    defaultPermissions: ["view"],
  },
  {
    fulllable: "Task Category",
    lable: "Task Cat",
    levelName: "taskcategory",
    permissions: ["list", "view", "update", "create", "delete"],
    defaultPermissions: ["view"],
  },
  {
    fulllable: "Task",
    lable: "Task",
    levelName: "task",
    permissions: ["list", "view", "update", "create", "delete"],
    defaultPermissions: ["view", "update", "create"],
  },
  {
    fulllable: "Task Comment",
    lable: "Task Comment",
    levelName: "taskcomment",
    permissions: ["list", "view", "update", "create", "delete"],
    defaultPermissions: ["view", "update", "create"],
  },
  {
    fulllable: "Task timer",
    lable: "Task Timer",
    levelName: "tasktimer",
    permissions: ["list", "view", "update", "create", "delete"],
    defaultPermissions: ["view", "update", "create"],
  },
  {
    fulllable: "Item",
    lable: "Item",
    levelName: "item",
    permissions: ["list", "view", "update", "create", "delete"],
    defaultPermissions: ["view", "update", "create"],
  },
  {
    fulllable: "Item Stock",
    lable: "Stock",
    levelName: "itemstock",
    permissions: ["list", "view", "update", "create", "delete"],
    defaultPermissions: ["view", "update", "create"],
  },
  {
    fulllable: "Item Category",
    lable: "Category",
    levelName: "category",
    permissions: ["list", "view", "update", "create", "delete"],
    defaultPermissions: ["view", "update", "create"],
  },

  {
    fulllable: "Brand",
    lable: "Brand",
    levelName: "brand",
    permissions: ["list", "view", "update", "create", "delete"],
    defaultPermissions: ["view", "update", "create"],
  },
  {
    fulllable: "Tax",
    lable: "Tax",
    levelName: "tax",
    permissions: ["list", "view", "update", "create", "delete"],
    defaultPermissions: ["view", "update", "create"],
  },
  {
    fulllable: "Tax Group",
    lable: "Tax Group",
    levelName: "taxgroup",
    permissions: ["list", "view", "update", "create", "delete"],
    defaultPermissions: ["view", "update", "create"],
  },
  {
    fulllable: "Sales Order",
    lable: "Sales",
    levelName: "salesorder",
    permissions: ["list", "view", "update", "create"],
    defaultPermissions: ["view", "update", "create"],
  },
  {
    fulllable: "Purchase Order",
    lable: "Purchase",
    levelName: "purchaseorder",
    permissions: ["list", "view", "update", "create"],
    defaultPermissions: ["view", "update", "create"],
  },
];
export const ImageSvg = () => (
  <svg viewBox="0 0 1024 1024" width="1em" height="1em" fill="currentColor">
    <g>
      <g>
        <path
          fill="#E5E1E5"
          d="M163.033,1011.756L2.746,191.353c-4.863-24.879,11.365-48.991,36.245-53.852l124.042-24.234l194.642-42.82
			l279.663,941.308H163.033V1011.756z"
        />
      </g>
      <path
        fill="#99E6FC"
        d="M163.033,680.979L68.355,196.393l94.678-18.501l143.802-23.615l62.994,584.599L163.033,680.979z"
      />
      <g id="XMLID_159_">
        <g>
          <path
            fill="#F9F7F8"
            d="M1014.357,64.9v957.461c0,25.351-20.549,45.899-45.899,45.899H208.93
			  c-25.351,0-45.901-20.549-45.901-45.899V64.9c0-25.35,20.551-45.9,45.901-45.9h759.528C993.809,19,1014.357,39.551,1014.357,64.9
			  z"
          />
        </g>
        <path
          fill="#EFEDEF"
          d="M574.473,971.206c-90.848,0-164.495-73.646-164.495-164.493V19H208.93
			c-25.351,0-45.901,20.551-45.901,45.9v957.461c0,25.351,20.551,45.899,45.901,45.899h759.528
			c25.351,0,45.899-20.549,45.899-45.899v-51.155H574.473z"
        />
        <path
          fill="#FEC165"
          d="M950.933,737.554V234.861c0-7.122-5.774-12.896-12.897-12.896H239.354c-7.12,0-12.896,5.774-12.896,12.896
			v502.692H950.933z"
        />
        <path
          fill="#FDB441"
          d="M409.978,221.965H239.354c-7.12,0-12.896,5.774-12.896,12.896v502.692h183.52V221.965z"
        />
        <circle fill="#FEE903" cx="588.693" cy="600.309" r="246.948" />
        <path
          fill="#F4D902"
          d="M409.978,770.729V429.889c-42.274,44.316-68.229,104.339-68.229,170.419
			C341.748,666.391,367.703,726.41,409.978,770.729z"
        />
        <g>
          <path
            fill="#99E6FC"
            d="M902.813,668.316c-57.591-25.393-122.604-28.267-182.203-8.034l-51.163,17.336
			  c-52.369,17.759-109.135,17.759-161.505,0l-51.163-17.336c-59.602-20.232-124.611-17.358-182.182,8.034l-48.142,21.226v105.269
			  l80.12,33.354h599.658l44.699-33.354V689.542L902.813,668.316z"
          />
          <path
            fill="#62DBFB"
            d="M409.978,828.165V649.264c-45.72-6.239-92.605,0.184-135.379,19.053l-48.141,21.226v105.269
			  l80.119,33.354H409.978z"
          />
          <path
            fill="#62DBFB"
            d="M950.933,794.811v61.709c0,5.452-4.424,9.878-9.879,9.878H236.332c-5.453,0-9.877-4.426-9.877-9.878
			  v-61.709l48.142-21.229c57.57-25.39,122.58-28.268,182.182-8.055l51.163,17.358c52.37,17.759,109.136,17.759,161.505,0
			  l51.163-17.358c59.6-20.213,124.612-17.335,182.203,8.055L950.933,794.811z"
          />
          <path
            fill="#01D0FB"
            d="M236.332,866.397h184.86c-7.214-18.51-11.215-38.625-11.215-59.685v-52.188
			  c-45.72-6.231-92.605,0.192-135.379,19.061l-48.141,21.226v61.71c-0.003,5.451,4.421,9.875,9.874,9.875V866.397z"
          />
        </g>
      </g>
    </g>
  </svg>
);
